var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttractions = function SvgAttractions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attraction"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10608 21.9847L7.10608 0.666672H15.2272L15.2272 21.9847H7.10608Z",
    fill: "#E45D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2877 21.4772V5.23483H27.4089V21.4772H19.2877Z",
    fill: "#E45D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3787 21.4772V13.356H33.4998V21.4772H25.3787Z",
    fill: "#FFAF61"
  }), /*#__PURE__*/React.createElement("g", {
    id: "attr-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M3.04544 14.8787C4.72739 14.8787 6.09088 13.5152 6.09088 11.8333C6.09088 10.1513 4.72739 8.78784 3.04544 8.78784C1.36349 8.78784 0 10.1513 0 11.8333C0 13.5152 1.36349 14.8787 3.04544 14.8787Z",
    fill: "#FFA656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03027 21.4772L2.03027 13.356H4.06056V21.4772H2.03027Z",
    fill: "#FFAF61"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43347 11.5359L17.7651 2.20433L27.0967 11.5359L17.7651 20.8676L8.43347 11.5359Z",
    fill: "#FD7435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    d: "M17.7651 16.1041C20.0077 16.1041 21.8256 14.2862 21.8256 12.0436C21.8256 9.80096 20.0077 7.98297 17.7651 7.98297C15.5225 7.98297 13.7045 9.80096 13.7045 12.0436C13.7045 14.2862 15.5225 16.1041 17.7651 16.1041Z",
    fill: "#FFA656"
  }))));
};
export default SvgAttractions;